import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import React, { useState, useEffect } from "react"
import {
  Col, Row, Button, Alert
} from "reactstrap"
import Switch from "react-switch"
import DPAlert from "framework/widgets/DPAlert"
import { loadPopupSearchPay } from "framework/validators/SearchColumn"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import ReactPaginate from 'react-paginate';


const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}
const VendorMasterTab3 = ({
  DataRow,
  show,
  AlertColor,
  AlertMsg,
  disabled,
  ErrorMsg,
  menuCode,
  setarRow,
  currentPage,
  setCurrentPage
}) => {
  // const [tabledata, SetTable] = useState([])

  // useEffect(() => {
  //   SetTable(DataRow)
  // }, [DataRow])

  const [HeadColumns, setHeadColumns] = useState([])
  const [postsPerPage] = useState(10)


  useEffect(async () => {
    setHeadColumns(await loadPopupSearchPay(menuCode, 'SUPTAX'))
  }, [menuCode]);

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };


  function handleAddRowNested() {

    // Check if there is any existing row with empty values
    const hasEmptyRow = DataRow.find(x => x.code == "");

    if (hasEmptyRow) {
      // If there is any row with empty values, do not add a new row
      return false;
    }

    const modifiedRows = [...DataRow]
    modifiedRows.push({
      id: modifiedRows.length + 1,
      code: "",
      taxCodeDisable: false,
      format: "",
      status: false,
      desc: "",
      inc: false,

    })
    setarRow(modifiedRows)
  }

  /**
    * @description This function is used to change the value of particular field in particular row.
    * @param {string} value - value of the row.
    * @param {string} id - id of the row.
    * @param {string} element - element of the row.
 */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setarRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  /**
  * @description This function is used to change the value of complete row.
  * @param {JSON} row - row of the table.
  * @param {string} id - id of the row.
*/

  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setarRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }

  function handleRemoveRow(id) {

    const modifiedRows = [...DataRow]
    const index = modifiedRows.findIndex(obj => obj.id === id)
    modifiedRows.splice(index, 1)

    if (modifiedRows.length == 0) {
      modifiedRows.push({
        id: modifiedRows.length + 1,
        code: "",
        taxCodeDisable: false,
        format: "",
        desc:"",
        status: false,
        inc: false,
      })
    }

    const newList = modifiedRows.map((item, index) => {
      item.id = index + 1
      return item
    })

    setarRow(newList)
  }
  
  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          {show ? (
            <Alert color={AlertColor} role="alert">
              {AlertMsg}
              <br />
              <small>{ErrorMsg}</small>
            </Alert>
          ) : null}

          <table style={{ fontSize: "11px" }} id={"taxdata"} >
            <thead className="table-light">
              <tr>
                <th>Code </th>
                <th></th>
                <th>Description </th>
                <th style={{ textAlign: "left" }}>Registration</th>
                <th style={{ textAlign: "center" }}>Tax Status</th>
                <th style={{ textAlign: "center" }}>Tax inclusive</th>
              </tr>
            </thead>
            <tbody disabled={true}>
              {currentPosts.map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  RemoveRow={handleRemoveRow}
                  Disabled={disabled}
                  HeadColumns={HeadColumns}
                  menuCode={menuCode}
                  handleObjectChange={handleObjectChange}
                  changeRowValueChanges={changeRowValueChanges}

                />
              ))}
            </tbody>
          </table>
          <Row sm={12} md={12} className="mb-4-sm">
            <Col>
              <Button
                onClick={() => {
                  handleAddRowNested()
                }}
                color="success"
                className="mt-1"
                disabled={disabled}
                size="sm"
              >
                <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
              </Button>
            </Col>
            <Col>
              <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                breakLabel={'...'}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={Math.ceil(DataRow.length / postsPerPage)}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                forcePage={currentPage - 1}
                renderOnZeroPageCount={null}
                activeClassName={'active'}
                activeLinkClassName={'page-link'}
                containerClassName={'pagination justify-content-end pagination-sm'}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default VendorMasterTab3

const TableRow = ({ FormRow, Key, RemoveRow, Disabled, HeadColumns, menuCode, changeRowValueChanges, handleObjectChange }) => {


  const [desc, setdesc] = useState(FormRow.desc != undefined ? FormRow.desc : "")

  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [groupFilter, SetGroupFilter] = useState("a")
  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const ApiURL = window.Links.ApiURL

  const [searchdisabled, SetSearchdisabled] = useState(false)

  //** Columns to be populated/Displayed within the Search window */


  //**Set the Default sort column and Sort order*/
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //********************************************/

  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.TAX_CODE, "taxcode" + Key)) {
      getData(row.TAX_CODE)

      var currentRow = FormRow
      currentRow.code = row.TAX_CODE
      currentRow.desc = row.TAX_DESC
      currentRow.taxCodeDisable = true
      handleObjectChange(currentRow, FormRow.id)
      SetSearchdisabled(true)

    } else {
      setsweetAlertShow(true)
      setAlertDescription("This Tax is already Used!!");
    }
    setmodal_xlarge(!modal_xlarge)
  }



  function getData(searchData) {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    if (searchData == "") return

    var currentRow = FormRow

    fetch(`${ApiURL}CustomerTax/search/${searchData}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          const newArray = responseData.data[0]
          var currentRow = FormRow
          // currentRow.code = searchData
          currentRow.code = newArray.code
          currentRow.desc = newArray.name
          currentRow.taxCodeDisable = true;

          handleObjectChange(currentRow, FormRow.id)
          SetSearchdisabled(true)

        } else {
          var currentRow = FormRow
          currentRow.code = ""
          currentRow.desc = ""
          currentRow.taxCodeDisable = false;

          handleObjectChange(currentRow, FormRow.id)
          setAlertDescription("Invalid code !")
          setsweetAlertShow(true)
        }
      })

  }


  // const getPaymentModeDets = async () => {
  //   const authToken = localStorage.getItem("authToken")
  //   const ApiURL = window.Links.ApiURL
  //   var data = [];
  //   var requestOptions = {
  //     method: 'GET',
  //     headers: {
  //       "Authorization": `Bearer ${authToken}`
  //     },
  //     redirect: 'follow'
  //   };
  //   await fetch(`${ApiURL}CustomerTax`, requestOptions)
  //     .then(response => response.json())
  //     .then(result => {
  //       //console.log(result)
  //       data = result.data;
  //     })
  //     .catch(error => console.log('error', error));
  //   return data;
  // }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  async function clickSearch() {
    tog_xlarge();
  }



  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  // //* Code Validation from repeating*/
  // const CodeValidation = (strCode, id) => {
  //   var tbl = document.getElementById("taxdata");
  //   if (tbl != null) {
  //     let rowCount = tbl.tBodies[0].rows.length;
  //     for (let i = 0; i < rowCount; i++) {
  //       var txtcode = document.getElementById("taxcode" + i)
  //       if ("taxcode" + i != id && txtcode.value == strCode) {
  //         return false
  //       }
  //     }
  //   }
  //   return true
  // }
  // //* End Code Validation   */


  //* Code Validation from repeating*/
  const CodeValidation = (strCode, id) => {
    var tbl = document.getElementById("taxdata");
    if (tbl != null) {
      let rowCount = tbl.tBodies[0].rows.length;
      for (let i = 0; i < rowCount; i++) {
        var txtcode = document.getElementById("taxcode" + i);
        if ("taxcode" + i !== id && txtcode.value.toLowerCase() === strCode.toLowerCase()) {
          return false;
        }
      }
    }
    return true;
  };
  //* End Code Validation */



  return (
    <tr key={FormRow.id}>

      <td style={{ width: "160px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPAlert
              confirm_both={sweetAlertShow}
              title={"Supplier Master !"}
              description={AlertDescription}
              showCancel={false}
              btnColor={"success"}
              cancelColor={"danger"}
              onConfirm={() => {
                setsweetAlertShow(false)
              }}
              btnYes={"OK"}
            />

            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"taxcode" + Key}
              value={FormRow.code}
              disabled={Disabled ? true : FormRow.taxCodeDisable}
              onChange={(e) => {
                changeRowValueChanges(e.target.value, FormRow.id, "code")
              }}
              onBlur={(e) => {
                if (CodeValidation(e.target.value, "taxcode" + Key)) {
                  changeRowValueChanges(e.target.value, FormRow.id, "code");
                  getData(e.target.value)
                } else {
                  setAlertDescription("This Tax is already Used!!");
                  setsweetAlertShow(true)
                  changeRowValueChanges("", FormRow.id, "code")
                  return;
                }
                if (!e.target.value.trim()) {
                  changeRowValueChanges("", FormRow.id, "desc")
                }
                SetSearchdisabled(false)
              }
              }
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              disabled={Disabled ? true : FormRow.taxCodeDisable}
              id={"btnSearch" + Key}
              onClick={clickSearch}
              size="sm">
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "400px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="5"
              id={"txtdesc" + Key}
              value={FormRow.desc}
              disabled="true"
              onChange={(e) => {
                setdesc(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              disabled={Disabled}
              textType="text"
              id={"taxformat" + Key}
              value={FormRow.format}
              onChange={(e) => {
                changeRowValueChanges(e.target.value, FormRow.id, "format")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>

      <td style={{ width: "80px", margin: "auto" }}>
        <Row className="mb-0">
          <Col md="12" style={{ textAlign: "center" }}>
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              onColor="#626ed4"
              height={23}
              disabled={Disabled}
              handleDiameter={15}
              onChange={(e) => {
                changeRowValueChanges(e, FormRow.id, "status")
              }}
              checked={FormRow.status}
              id={"taxstatus" + Key}
            />
          </Col>
        </Row>
      </td>

      <td style={{ width: "90px", margin: "auto" }}>
        <Row className="mb-0">
          <Col md="12" style={{ textAlign: "center" }}>
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              onColor="#626ed4"
              height={23}
              disabled={Disabled}
              handleDiameter={15}
              onChange={(e) => {
                changeRowValueChanges(e, FormRow.id, "inc")
              }}
              checked={FormRow.inc}
              id={"taxinc" + Key}
            />
          </Col>
        </Row>
      </td>

      <td>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              color="danger"
              disabled={Disabled}
              id={"btnDelete" + Key}
              onClick={e => {
                RemoveRow(FormRow.id)
              }}
              size="sm">
              <i
                className="mdi mdi-delete"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>{" "}

          <DPSearchBoxDynamic
            searchData={[]}
            columns={HeadColumns}
            defaultSorted={defaultSorted}
            mainTitle={"TAX Detail Search"}
            SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            getSelect={Hed_SelectRowSearch}
            APIURL={ApiURL}
            URLPath={"SUPTAX"}
            MenuCode={menuCode}
            KeyVal={"TAX"}
            searchBy={"TAX_CODE"}
            FilterStr={groupFilter}
          />

        </Row>
      </td>
    </tr>
  )
}
